import { Link } from "@tanstack/react-router";

import Icon from "@/components/Icon/Icon";
import HStack from "@/components/Layout/HStack";
import VStack from "@/components/Layout/VStack";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import type { DeviceGenre } from "@/constants/device";
import { useDeviceGenre } from "@/features/device/genre/useDeviceGenre";

type Props = {
  id: string;
  avatarUrl?: string;
  name: string;
  model: string | null;
  genre: DeviceGenre;
};

export default function DeviceCell({
  id,
  avatarUrl,
  name,
  model,
  genre,
}: Props) {
  const { icon } = useDeviceGenre();

  return (
    <HStack className="items-center gap-3">
      <Avatar className="rounded-sm">
        <AvatarImage src={avatarUrl} alt={name} className="object-contain" />
        <AvatarFallback>
          <Icon className="h-5 w-5" iconName={icon(genre)} />
        </AvatarFallback>
      </Avatar>
      <VStack className="font-semibold">
        <Link
          to="/profile/device/$id"
          params={{ id: id }}
          className="text-sm hover:underline"
        >
          {name}
        </Link>
        <div className="text-xs text-muted-foreground">{model}</div>
      </VStack>
    </HStack>
  );
}
